import { render } from "./ChatMessageThreadModal.vue?vue&type=template&id=a61a01b6&scoped=true"
import script from "./ChatMessageThreadModal.vue?vue&type=script&lang=js"
export * from "./ChatMessageThreadModal.vue?vue&type=script&lang=js"

import "./ChatMessageThreadModal.vue?vue&type=style&index=0&id=a61a01b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a61a01b6"]])

export default __exports__